<template>
  <div class="product__action" v-if="product">
    <button @click="buyNow()" class="btn btn--purple" href="#" :disabled="!isAvailable || submitting" v-if="buyNowButton">{{ buyNowText }}</button>
    <button @click="addToCart()" class="btn btn--white" href="#" :disabled="!isAvailable" v-if="addToCartButton"><i class="cart__icon icon-cart"></i> Add to cart</button>
  </div>
</template>

<script>
export default {
  name: 'ProductCartAction',
  props: {
    product: {
      type: Object,
      required: false,
      default: null
    },
    initialQuantity: {
      type: Number,
      required: true
    },
    stockAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    attributes: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    addToCartButton: {
      type: Boolean,
      default: true
    },
    buyNowButton: {
      type: Boolean,
      default: true
    },
    buyNowText: {
      type: String,
      default: 'บริจาค'
    }
  },
  data () {
    return {
      quantity: this.initialQuantity,
      isAvailable: false,
      submitting: false
    }
  },
  created () {
    setInterval(() => {
      this.isAvailable = this.$utils.isProductAvailable(this.product) && this.stockValid()
    }, 250)
  },
  methods: {
    stockValid () {
      if (!this.product) {
        return false
      }
      return this.product.type !== this.$const.PRODUCT_TYPES.STOCK || this.stockAvailable
    },
    checkProductType () {
      // check product type
      if (!this.product) {
        return false
      }
      if (this.product.type === this.$const.PRODUCT_TYPES.CATALOG) {
        this.$modal.show({
          title: 'ไม่สามารถเพิ่มกลุ่มรายการได้',
          text: 'กรุณาเลือกรายการในหน้ารายละเอียดกลุ่มรายการแทน'
        })
        return false
      }
      return true
    },
    checkValidMaxQuantity () {
      if (!this.product) {
        return false
      }
      let cartItem = this.$store.state.cart.find(item => {
        return item.product.sku === this.product.sku
      })

      let cartQuantity = this.quantity
      if (cartItem) {
        cartQuantity += cartItem.quantity
      }

      if (this.product.maxQuantity > 0 && cartQuantity > this.product.maxQuantity) {
        this.$modal.show({
          title: 'มีบางอย่างไม่ถูกต้อง',
          text: `จำนวนรายการ ${this.product.name} เกินค่าที่จำกัดไว้ (${this.product.maxQuantity} รายการ) กรุณาตรวจสอบอีกครั้ง`
        })
        return false
      }
      return true
    },
    buyNow () {
      if (this.submitting) {
        return
      }
      this.submitting = true

      if (!this.product || !this.checkProductType() || !this.checkValidMaxQuantity()) {
        this.submitting = false
        return
      }

      if (!this.addToCart()) {
        return
      }

      let changeRoute = this.quantity && this.quantity > 0
      if (changeRoute) {
        if (this.product.type === this.$const.PRODUCT_TYPES.DONATE) {
          this.$router.push({ name: 'checkout', query: {force_credit_card: this.$route.query.force_credit_card} })
        } else {
          this.$router.push({ name: 'cart' })
        }
      }

      this.$utils.fbTrack('buyNow', this.quantity, { sku: this.product.sku })
    },
    addToCart () {
      if (!this.product || !this.checkProductType() || !this.checkValidMaxQuantity()) {
        return false
      }
      this.$outdated.checkBrowser(true)

      if (!this.$utils.isProductAvailable(this.product)) {
        this.$store.state.toast.showToast('ขออภัย รายการนี้ยังไม่เปิดให้บริการ')
        return false
      }

      if (this.quantity && this.quantity > 0) {
        this.$utils.addToCart(this.product, this.attributes, this.quantity)
        if (this.product.type !== this.$const.PRODUCT_TYPES.DONATE) {
          this.$store.state.toast.showToast(`เพิ่มรายการ ${this.quantity} รายการ`, { timeLife: 1200 })
        }
      } else {
        this.$modal.show({
          title: 'มีบางอย่างไม่ถูกต้อง',
          text: 'จำนวนรายการไม่สามารถเป็นศูนย์ได้ กรุณาเลือกรายการใหม่หรือเพิ่มจำนวนก่อนทำรายการ'
        })
        return false
      }
      this.quantity = 1
      this.$emit('resetQuantity')

      return true
    },
    setQuantity (value) {
      this.quantity = value
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// ProductCartAction.vue?340d68d2